import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { CSVLink } from 'react-csv';
import { toast } from 'react-toastify';
import { Button, Icon, Modal } from 'semantic-ui-react';
import { Progress } from 'semantic-ui-react';
import agent from '../../app/api/agent';
import { useStore } from '../../app/stores/store';
interface Props {
  totalCountData: number;
  tableName: string;
}

function MetaDataModal({ totalCountData, tableName }: Props) {
  const {
    reportStore,
    userStore: { user },
  } = useStore();
  const [showProgress, setShowProgress] = useState(false);
  const [showMoveToBackGround, setShowMoveToBackGround] = useState(false);
  const [fullMetaDataReport, setFullMetaDataReport] = useState<any>([]);
  const [progressBarLength, setProgressBarLength] = useState(0);
  const [enableDownload, setEnableDownload] = useState(false);
  const pageSize = 25;

  const handleProgressDownload = async () => {
    setEnableDownload(false);
    let AsyncCallLength = Math.ceil(totalCountData / 25);
    let mainArr: any = [];
    let localProgressBarLength = 0;
    for (let i = 1; i <= AsyncCallLength; i++) {
      try {
        let text = localStorage.getItem(`${tableName}`)!;
        if (text.includes(',')) {
          const countResponse2 = await agent.Reports.reportsWithPaginationPost(
            i,
            pageSize,
            text?.split(','),
          );
          if (countResponse2.data !== 'Item Not Found') {
            const parsedData = JSON.parse(countResponse2.data);
            if (
              (tableName === 'AssetTable' || tableName === 'ReportsTable') &&
              user?.customerName === 'LVPCMS'
            ) {
              let newArr = parsedData.filter((x: any) => {
                return x.type !== 'Film Festival';
              });
              Array.prototype.push.apply(mainArr, newArr);
            } else if (
              tableName === 'ProjectReport' &&
              user?.customerName === 'LVPCMS'
            ) {
              let newArr = parsedData.filter((x: any) => {
                return x.type === 'Film Festival';
              });
              Array.prototype.push.apply(mainArr, newArr);
            } else {
              Array.prototype.push.apply(mainArr, parsedData);
            }
          }
          setProgressBarLength(localProgressBarLength + 25);
          localProgressBarLength += 25;
        } else {
          const countResponse2 = await agent.Reports.reportsWithPaginationPost(
            i,
            pageSize,
            [text],
          );
          if (countResponse2.data !== 'Item Not Found') {
            const parsedData = JSON.parse(countResponse2.data);
            if (
              (tableName === 'AssetTable' || tableName === 'ReportsTable') &&
              user?.customerName === 'LVPCMS'
            ) {
              let newArr = parsedData.filter((x: any) => {
                return x.type !== 'Film Festival';
              });
              Array.prototype.push.apply(mainArr, newArr);
            } else if (
              tableName === 'ProjectReport' &&
              user?.customerName === 'LVPCMS'
            ) {
              let newArr = parsedData.filter((x: any) => {
                return x.type === 'Film Festival';
              });
              Array.prototype.push.apply(mainArr, newArr);
            } else {
              Array.prototype.push.apply(mainArr, parsedData);
            }
          }
          setProgressBarLength(progressBarLength + 25);
          localProgressBarLength += 25;
        }
      } catch (err) {
        toast.error('some error occured');
        console.log(err);
      }
    }

    setFullMetaDataReport(mainArr);
    setEnableDownload(true);
  };
  const sendEmailFunction = () => {
    let text = localStorage.getItem('ReportsTable')!;
    if (text.includes(',')) {
      agent.Reports.downloadMetaDataEmail(text?.split(','));
      toast.success('Email Sent Successfully');
    } else {
      agent.Reports.downloadMetaDataEmail([text]);
      toast.success('Email Sent Successfully');
    }
    reportStore.setOpenMetaDataReportModal(false);
  };
  const secondsToMinutes = () => {
    let secondsData = Math.ceil((totalCountData * 6) / 25);
    return Math.ceil(secondsData / 60).toString();
  };
  return (
    <Modal
      onClose={() => reportStore.setOpenMetaDataReportModal(false)}
      onOpen={() => reportStore.setOpenMetaDataReportModal(true)}
      open={reportStore.openMetaDataReportModal}
    >
      <Modal.Header>Meta Data Download Confirmation</Modal.Header>

      <Modal.Content style={{ height: '9vh', color: 'black' }}>
        {!showProgress && !showMoveToBackGround && (
          <h3>
            Do you prefer waiting or do you want to move this activity to
            backend. If you move to backend, the report will be sent through
            email
          </h3>
        )}
        {showProgress && !showMoveToBackGround && (
          <Progress
            indicating
            active
            value={progressBarLength}
            total={totalCountData}
            progress="percent"
          >
            Estimated Time {secondsToMinutes()} minutes{' '}
          </Progress>
        )}
        {!showProgress && showMoveToBackGround && (
          <h3>The report will be sent to your E-mail.</h3>
        )}
      </Modal.Content>
      <Modal.Actions>
        {/* For Move to Background */}
        {!showProgress && !showMoveToBackGround && (
          <Button
            onClick={() => setShowMoveToBackGround(true)}
            floated="left"
            primary
          >
            Move To Background
          </Button>
        )}
        {!showProgress && showMoveToBackGround && (
          <Button
            positive
            floated="left"
            style={{ marginBottom: '20px' }}
            onClick={() => sendEmailFunction()}
          >
            Ok
          </Button>
        )}

        {/* For Progress Download */}
        {!showProgress && !showMoveToBackGround && (
          <Button.Group>
            <Button
              onClick={() => reportStore.setOpenMetaDataReportModal(false)}
            >
              {' '}
              Close
            </Button>
            <Button.Or />
            <Button
              positive
              onClick={() => {
                setShowProgress(true);
                handleProgressDownload();
              }}
            >
              Continue
            </Button>
          </Button.Group>
        )}

        {/* For Progress Download */}
        {showProgress && !showMoveToBackGround && (
          <CSVLink
          filename={tableName}
            data={fullMetaDataReport}
            style={{
              marginLeft: '40px',
              pointerEvents: !enableDownload ? 'none' : 'auto',
              opacity: !enableDownload ? '0.7' : '1',
            }}
            onClick={() => reportStore.setOpenMetaDataReportModal(false)}
          >
            <Icon
              corner="bottom right"
              size="large"
              circular
              inverted
              color="teal"
              name="download"
            />
          </CSVLink>
        )}
      </Modal.Actions>
    </Modal>
  );
}

export default observer(MetaDataModal);
